import { Injectable } from '@angular/core';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { MUser } from '@argalis-apps/models';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private communicationConfigService: CommunicationConfigService
  ) {}

  saveUser(user: MUser.IUser) {
    const result = new Subject<MUser.IUser>();
    if (this.configService.getOptions().useTestData === true) {
      setTimeout(() => result.next(user));
    } else {
      this.http
        .put<MUser.IUser>(`${this.communicationConfigService.getApiUri()}/user/client/type/`, user)
        .subscribe((data: MUser.IUser) => result.next(data), () => result.next(null));
    }
  }

  getClientType(): Observable<{ id: number; libelle: string; code: string }[]> {
    const result = new Subject<{ id: number; libelle: string; code: string }[]>();

    if (this.configService.getOptions().useTestData === true) {
      setTimeout(() =>
        result.next([
          { id: 1, libelle: 'Entreprise', code: 'ENTR' },
          { id: 2, libelle: 'Particulier à titre individuel', code: 'PART' },
          { id: 3, libelle: 'Organisme de formation', code: 'OF' },
          { id: 4, libelle: 'OPCA ou OPACIF', code: 'OP' },
          { id: 5, libelle: 'Autre', code: 'AUTRE' }
        ])
      );
    } else {
      this.http
        .get<{ id: number; libelle: string; code: string }[]>(
          `${this.communicationConfigService.getApiUri()}/client/type`
        )
        .subscribe(
          (data: { id: number; libelle: string; code: string }[]) => result.next(data),
          () => result.next([])
        );
    }
    return result;
  }

  getClientApprenants(idClient: number): Observable<MUser.IContact[]> {
    const result = new Subject<MUser.IContact[]>();

    if (!this.configService.getOptions().useTestData) {
      this.http.get<MUser.IContact[]>(
        `${this.communicationConfigService.getApiUri()}/user/${MUser.ETypeUser.CLIENT}/${idClient}/apprenant`
      );
    }

    return result;
  }
}
